import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonParse'
})
export class JsonParsePipe implements PipeTransform {

  transform(value: string, defaultValue: any = null): any {
    if(value){
      return JSON.parse(value);
    }
    return defaultValue;
  }
}

@Pipe({
  name: 'jsonPretty',
  standalone: true
})
export class JsonPrettyPipe implements PipeTransform {

  transform(value: string | object): string {
    if(value){
      if(typeof value === "string"){
        return JSON.stringify(JSON.parse(value), null, 2);
      }
      else{
        return JSON.stringify(value, null, 2);
      }
    }
    return null;

  }
}
